import { defaultEntityState } from '@app/core/state/entities/entity';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
  removeEntitiesWithIds,
} from '@app/core/state/entities/entity.helpers';
import { projectDetailActions } from '@app/core/actions/project-detail.actions';
import { stageActions } from '@app/core/actions/stage.actions';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '../entity-name-map';
import { IMembershipScreeningStats } from '@core/state/entities/membership-screening-stats/membership-screening-stats.entity';

export const membershipScreeningStatsEntityReducer = createReducer(
  defaultEntityState<IMembershipScreeningStats>(),
  on(
    projectDetailActions.screeningSummaryReceived,
    stageActions.receivedFullStats,
    projectDetailActions.fullProjectStatsReceived,
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    (state, props) =>
      mergeEntityState(entityKey.membershipScreeningStats, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
